import r from "../../shared-lib/braze-shared-lib.js";
import e from "../managers/braze-instance.js";
import { newFeatureFlagFromJson as et } from "./feature-flag-factory.js";
import FeatureFlag from "./feature-flag.js";
import ir from "./feature-flags-provider-factory.js";
export function getFeatureFlag(a) {
  if (!e.rr()) return;
  if (!e.ir()._e())
    return r.D.info("Feature flags are not enabled."), new FeatureFlag(a);
  const t = ir.er().xe();
  return t[a] ? et(t[a]) : new FeatureFlag(a);
}
